export enum LANDLORD_TYPE {
  IND = 'IND',
  CORP = 'CORP',
}
